import { cva } from "class-variance-authority";
import { cn } from "cn";
import type { ComponentProps, FC } from "react";
import React from "react";

import { Skeleton as BaseSkeleton } from "../shadcn/ui/skeleton.tsx";

import type { VariantProps } from "./lib.ts";

export * from "../shadcn/ui/skeleton.tsx";

const skeletonVariants = cva("", {
  defaultVariants: { deferred: false, variant: "default" },
  variants: {
    deferred: { true: "animate-skeleton-appear" },
    variant: {
      "default": "",
      "text-label": "h-4 w-48",
      "text-line": "h-4 w-full",
    },
  },
});

interface SkeletonProps
  extends ComponentProps<typeof BaseSkeleton>,
    VariantProps<typeof skeletonVariants> {}

export const Skeleton: FC<SkeletonProps> = ({
  className,
  deferred,
  variant,
  ...props
}) => (
  <BaseSkeleton
    className={cn(skeletonVariants({ deferred, variant }), className)}
    {...props}
  />
);
